import * as React from 'react';

import { Pagination } from '@mui/material';
import { ChangeEvent } from 'react';
import { gray100, primaryColor, white } from '../../constants/Colors';

const styles = {
  pagination: {
    '& .MuiPagination-ul': {
      justifyContent: 'center'
    },
    '& .MuiButtonBase-root.MuiPaginationItem-root': {
      '&.Mui-selected': {
        backgroundColor: primaryColor,
        color: white
      }
    },
    '@media screen and (max-width:600px)': {
      mt: '80px'
    },
    color: gray100,
    mt: '120px',
    mb: '120px'
  }
};

interface Props {
  currentPage: number;
  totalPages: number;
  handlePageChange: (event: ChangeEvent<unknown>, page: number) => void;
}

const CustomPagination = (props: Props): React.ReactElement => {
  const { currentPage, totalPages, handlePageChange } = props;

  return (
    <Pagination
      sx={styles.pagination}
      count={totalPages}
      page={currentPage}
      onChange={handlePageChange}
    />
  );
};
export default CustomPagination;
